import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { traderApi } from "./trader-api";
import { api } from "./api";
import authSlice, { logout } from "./slices/authSlice";
import uiSlice from "./slices/uiSlice";

// Создаем middleware для очистки кэша при logout
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: logout,
  effect: async (action, listenerApi) => {
    // Очищаем кэш RTK Query при выходе
    listenerApi.dispatch(traderApi.util.resetApiState());
  },
});



export const store = configureStore({
  reducer: {
    [traderApi.reducerPath]: traderApi.reducer,
    [api.reducerPath]: api.reducer, // Add this
    auth: authSlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    })
      .concat(traderApi.middleware)
      .concat(api.middleware) // Add this
      .prepend(listenerMiddleware.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
